export default {
  dateTimeBooking: "予約日時",
  numberOfPeople: "人数",
  numberOfPet: "ペット",
  product: "商品",
  bookingCode: "予約番号",
  customerInfo: "お客様情報",
  facilityNote: "施設側のメモ"
};
